import { emptyObj } from '@beef/utils';
import { createSelector } from 'reselect';
import { getFTTBExtraServices } from './servicesSelectors';
import { SERVICE_TYPE } from '../../constants';
import { getFTTB } from './commonSelectors';

const withOnlySocialInternet = ({ serviceType }) => serviceType === SERVICE_TYPE.socialInternet;
const getFTTBSocialInternetData = (state) => getFTTB(state).socialInternetPopup || emptyObj;

export const getFTTBSocialInternetService = (state) => getFTTBExtraServices(state).find(withOnlySocialInternet) || emptyObj;
export const getFTTBSocialInternetDataPopup = (state) => getFTTBSocialInternetData(state).popup || emptyObj;
export const getFTTBSocialInternetUrlEsia = (state) => getFTTBSocialInternetData(state).urlEsia || '';
export const getFTTBIsSocialInternetPopupOpen = (state) => getFTTBSocialInternetData(state).isOpen;

export const getSocialInternetSwitcherIsDisabled = createSelector(
  getFTTBSocialInternetService,
  getFTTBIsSocialInternetPopupOpen,
  (service, isOpen) => service.isDisabled || service.isChecked || isOpen,
);

export const getSocialInternetSwitcherIsLoading = createSelector(
  getFTTBSocialInternetService,
  getFTTBIsSocialInternetPopupOpen,
  ({ isLoading }, isPopupOpen) => isLoading || isPopupOpen,
);
